import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { NotifyService } from "@core/services/notify.service";
import { PartService } from "@core/services/part.service";
import { PartManufacturerDTO } from "@shared/models/part-manufacturer-dto";
import { PartManufacturerDriveBAutoCompleteComponent } from "@shared/widgets/part-manufacturer-driveb-auto-complete/part-manufacturer-driveb-auto-complete.component";

@Component({
    selector: "app-driveb-create-part-derivation-modal",
    templateUrl: "./create-part-derivation-modal.component.html",
    styleUrls: ["./create-part-derivation-modal.component.scss"],
    standalone: false
})
export class CreatePartDerivationModalComponent implements OnInit {
  form = this.fb.group({
    partCode: [
      "",
      [
        Validators.required,
        Validators.pattern(
          /^[^<>!@#$%¨&*()^~{[\]}?"'+=.,ºª§:°;\\|_´`.¹²³£¢¬]*$/
        )
      ]
    ],
    segment: ["", [Validators.required]],
    partManufacturerName: ["", [Validators.required]],
    partManufacturerId: ["", [Validators.required]]
  });

  segments: { value: number; name: string }[] = null;

  @ViewChild("partManufacturerAutocomplete", { static: false })
  partManufacturerAutocomplete: PartManufacturerDriveBAutoCompleteComponent;

  constructor(
    private fb: UntypedFormBuilder,
    private partService: PartService,
    private notifyService: NotifyService,
    private matDialogRef: MatDialogRef<CreatePartDerivationModalComponent>
  ) {}

  ngOnInit() {
    this.getSegments();
  }

  save() {
    if (this.form.valid) {
      this.matDialogRef.close(this.form.getRawValue());
    } else {
      this.form.markAllAsTouched();
      this.partManufacturerAutocomplete.markAsTouched();
    }
  }

  closeDialog(): void {
    this.matDialogRef.close();
  }

  handlePartManufacturerChange(partManufacturer: PartManufacturerDTO): void {
    this.form.get("partManufacturerName").setValue(partManufacturer.name);
    this.form.get("partManufacturerId").setValue(partManufacturer.id);
  }

  getSegments() {
    this.partService.getSegments().subscribe(
      (segments) => {
        this.segments = segments.map((segment) => ({
          value: segment.id,
          name: segment.translation.value
        }));
      },
      (error) => {
        this.notifyService.showErrorMessageWithTranslationKey(
          "default-error-message",
          error,
          "Error to get part segments"
        );
      }
    );
  }

  verifyIfPartCodeAlreadyExists() {
    const partCodeAbstractControl = this.form.get("partCode");

    if (!partCodeAbstractControl.value) {
      partCodeAbstractControl.updateValueAndValidity();
      return;
    }

    this.partService
      .partCodeAlreadyExists(partCodeAbstractControl.value)
      .subscribe(
        (alreadyExists) => {
          alreadyExists
            ? partCodeAbstractControl.setErrors({ alreadyExists })
            : partCodeAbstractControl.updateValueAndValidity();
        },
        (error) => {
          this.notifyService.showErrorMessageWithTranslationKey(
            "default-error-message",
            error,
            "Error to verify if part code already exists"
          );
        }
      );
  }
}
